import { render } from "./Message.vue?vue&type=template&id=fdb873d6&ts=true"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Build\\TCF\\ABBp_PIS\\6.15\\PisNextGenExtProd-PisApp_6_15_0\\PisNextGenExtProd\\PisNextGen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__